import React from 'react';

export default function ScenarioCaseRenderer({ question, value, onChange }) {
  if (!question) return null;

  const optionEntries = Array.isArray(question.options)
    ? question.options.map((opt) => [opt.key, opt.text])
    : Object.entries(question.options || {});

  return (
    <div>
      <div className="rounded-2xl border border-amber-200/40 bg-[rgba(255,248,220,0.92)] p-5 text-slate-900">
        <p className="font-semibold tracking-wide">SCENARIO:</p>
        <p className="mt-2 italic leading-7 whitespace-pre-wrap">{question.scenario || question.question}</p>
      </div>

      <div className="mt-4 rounded-2xl border border-white/20 bg-slate-900/55 backdrop-blur-xl p-5">
        <p className="text-lg leading-8 font-jakarta text-white">{question.prompt || question.question}</p>
      </div>

      <div className="mt-4 space-y-3">
        {optionEntries.map(([key, text]) => {
          const selected = value === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(key)}
              className={`w-full text-left px-4 py-3 rounded-xl border transition ${selected ? 'border-emerald-300 bg-gradient-to-r from-emerald-500 to-teal-600 text-white' : 'border-white/25 bg-slate-800/60 text-white hover:border-emerald-400/70 hover:bg-slate-700/70'}`}
            >
              <span className="font-semibold mr-2">{key}.</span>
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
